var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _circle3, _circle4, _circle5, _path6, _circle6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle7, _circle8, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.35,
    x2: 295.984,
    xlinkHref: "#lg1",
    y1: 27.85,
    y2: 85.484
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.456,
    x2: 264.424,
    xlinkHref: "#lg2",
    y1: 10.38,
    y2: 58.157
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.289
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.729,
    x2: 272.625,
    xlinkHref: "#lg3",
    y1: 27.629,
    y2: -43.337
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 25.131,
    y2: 48.545
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bec3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#808797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e8595"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.087,
    x2: 267.906,
    xlinkHref: "#lg4",
    y1: 55.013,
    y2: 99.906
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7e8595",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7e8595"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.357,
    x2: 259.114,
    xlinkHref: "#lg5",
    y1: 26.977,
    y2: 154.119
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 253.475,
    x2: 259.025,
    xlinkHref: "#lg5",
    y1: 28.084,
    y2: 150.656
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 176.141,
    x2: 470.163,
    xlinkHref: "#lg1",
    y1: 205.923,
    y2: 499.946
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 245.24,
    x2: 167.33,
    y1: 260.498,
    y2: 66.652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9edf5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(-1 0 0 -1 510 510)",
    gradientUnits: "userSpaceOnUse",
    x1: 192.183,
    x2: 426.394,
    xlinkHref: "#lg1",
    y1: 162.4,
    y2: 396.611
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.321,
    x2: 142.688,
    xlinkHref: "#lg3",
    y1: 318.898,
    y2: 288.329
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.238,
    x2: 407.143,
    xlinkHref: "#lg4",
    y1: 229.021,
    y2: 436.926
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 379.007,
    x2: 262.191,
    xlinkHref: "#lg5",
    y1: 284.783,
    y2: 284.783
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.784,
    x2: 329.258,
    y1: 184.781,
    y2: 286.255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f92814"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.139,
    x2: 338.291,
    y1: 176.567,
    y2: 276.719
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f92814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1272d"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 248.802,
    x2: 217.299,
    y1: 202.337,
    y2: 193.071
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 0 0 -1 0 330.155)",
    gradientUnits: "userSpaceOnUse",
    x1: 227.784,
    x2: 329.258,
    xlinkHref: "#lg1",
    y1: -54.629,
    y2: 46.845
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 0 0 -1 0 330.155)",
    gradientUnits: "userSpaceOnUse",
    x1: 238.139,
    x2: 338.291,
    xlinkHref: "#lg3",
    y1: -62.844,
    y2: 37.309
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 0 0 -1 0 330.155)",
    gradientUnits: "userSpaceOnUse",
    x1: 248.802,
    x2: 217.299,
    xlinkHref: "#lg2",
    y1: -37.074,
    y2: -46.339
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 238.35,
    x2: 295.984,
    y1: 268.133,
    y2: 325.767
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.433,
    x2: 219.162,
    y1: 289.215,
    y2: 248.945
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.545,
    x2: 317.712,
    y1: 301.837,
    y2: 188.075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 165.941,
    x2: 107.673,
    xlinkHref: "#lg5",
    y1: 324.385,
    y2: 228.174
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.953,
    x2: 356.223,
    xlinkHref: "#lg5",
    y1: 319.106,
    y2: 275.058
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.387,
    x2: 131.387,
    y1: 282.349,
    y2: 303.852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#92f37f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab272"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.613,
    x2: 378.613,
    y1: 282.349,
    y2: 303.852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a98f7"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 44.5,
    fill: "url(#SVGID_1_)",
    r: 44.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 44.5,
    fill: "url(#SVGID_2_)",
    r: 37.139
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m274.906 4.693c3.001 5.99 4.693 12.75 4.693 19.906 0 24.577-19.923 44.5-44.5 44.5-7.156 0-13.916-1.692-19.906-4.693 7.307 14.582 22.387 24.593 39.807 24.593 24.576 0 44.5-19.923 44.5-44.5 0-17.42-10.012-32.5-24.594-39.806z",
    fill: "url(#SVGID_3_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m210.5 44.5c0 24.576 19.923 44.5 44.5 44.5s44.5-19.923 44.5-44.5c0-10.7-3.779-20.516-10.072-28.192h-68.855c-6.294 7.676-10.073 17.492-10.073 28.192z",
    fill: "url(#SVGID_4_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m302.735 84.708h-95.47c-2.421 0-4.384-1.963-4.384-4.384v-32.545c0-7.377 5.98-13.357 13.357-13.357h77.523c7.377 0 13.357 5.98 13.357 13.357v32.545c0 2.421-1.962 4.384-4.383 4.384z",
    fill: "url(#SVGID_5_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m288.438 84.708h-66.877c-2.044 0-3.701-1.657-3.701-3.7v-35.31c0-6.227 5.048-11.275 11.275-11.275h51.727c6.227 0 11.275 5.048 11.275 11.275v35.31c.002 2.043-1.655 3.7-3.699 3.7z",
    fill: "url(#SVGID_6_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m265.945 84.708h-21.891c-1.216 0-2.202-.986-2.202-2.202v-41.375c0-3.705 3.004-6.709 6.709-6.709h12.877c3.705 0 6.709 3.003 6.709 6.709v41.376c0 1.215-.986 2.201-2.202 2.201z",
    fill: "url(#SVGID_7_)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 284.783,
    fill: "url(#SVGID_8_)",
    r: 225.217
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 284.783,
    fill: "url(#SVGID_9_)",
    r: 212.17
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 284.783,
    fill: "url(#SVGID_10_)",
    r: 179.403
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m476.636 324.985-215.22-215.219c-1.856-6.649-11.774-6.422-13.026.724l-25.054 143.034c-7.934 8.036-12.836 19.074-12.836 31.259s4.902 23.223 12.836 31.259l25.054 143.034c.512 2.924 2.485 4.675 4.759 5.289l42.054 42.054c92.156-16.607 164.826-89.278 181.433-181.434z",
    fill: "url(#SVGID_11_)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 284.783,
    fill: "url(#SVGID_12_)",
    r: 159.253
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m414.253 284.783c0-8.15-.615-16.156-1.796-23.976l-133.48-133.48c-7.82-1.181-15.826-1.796-23.976-1.796-3.12 0-6.217.1-9.293.277l-22.371 127.717c-7.934 8.036-12.836 19.074-12.836 31.259s4.902 23.223 12.836 31.259l22.371 127.717c3.076.177 6.172.277 9.293.277 87.952-.002 159.252-71.302 159.252-159.254z",
    fill: "url(#SVGID_13_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m248.39 110.49-30.529 174.293h74.277l-30.528-174.293c-1.297-7.404-11.923-7.404-13.22 0z",
    fill: "url(#SVGID_14_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m292.139 284.783-30.529-174.293c-.648-3.702-3.629-5.552-6.61-5.552v179.845z",
    fill: "url(#SVGID_15_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m225.222 284.783h29.778v-170.005z",
    fill: "url(#SVGID_16_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m248.39 459.075-30.529-174.293h74.277l-30.528 174.293c-1.297 7.404-11.923 7.404-13.22 0z",
    fill: "url(#SVGID_17_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m292.139 284.783-30.529 174.292c-.648 3.702-3.629 5.553-6.61 5.553v-179.845z",
    fill: "url(#SVGID_18_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m225.222 284.783h29.778v170.004z",
    fill: "url(#SVGID_19_)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 284.783,
    fill: "url(#SVGID_20_)",
    r: 44.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 255,
    cy: 284.783,
    fill: "url(#SVGID_21_)",
    r: 37.139
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m274.906 244.976c3.001 5.99 4.693 12.75 4.693 19.906 0 24.576-19.923 44.5-44.5 44.5-7.156 0-13.916-1.692-19.906-4.693 7.306 14.582 22.386 24.594 39.807 24.594 24.576 0 44.5-19.923 44.5-44.5 0-17.421-10.012-32.501-24.594-39.807z",
    fill: "url(#SVGID_22_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m150.218 278.012c-1.917-2.249-4.765-3.68-7.952-3.68h-21.759c-5.772 0-10.45 4.679-10.45 10.45 0 3.131 1.384 5.933 3.565 7.848l53.352 53.873c1.917 2.249 4.765 3.68 7.952 3.68h21.759c5.772 0 10.45-4.679 10.45-10.45 0-3.131-1.384-5.933-3.565-7.848z",
    fill: "url(#SVGID_23_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m397.445 278.012c-1.917-2.249-4.765-3.68-7.952-3.68h-21.759c-5.772 0-10.45 4.679-10.45 10.45 0 3.131 1.384 5.933 3.565 7.848l53.352 53.873c1.917 2.249 4.765 3.68 7.952 3.68h21.759c5.772 0 10.45-4.679 10.45-10.45 0-3.131-1.384-5.933-3.565-7.848z",
    fill: "url(#SVGID_24_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m142.266 295.233h-21.759c-5.772 0-10.45-4.679-10.45-10.45 0-5.772 4.679-10.45 10.45-10.45h21.759c5.772 0 10.45 4.679 10.45 10.45.001 5.771-4.678 10.45-10.45 10.45z",
    fill: "url(#SVGID_25_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m389.493 295.233h-21.759c-5.772 0-10.45-4.679-10.45-10.45 0-5.772 4.679-10.45 10.45-10.45h21.759c5.772 0 10.45 4.679 10.45 10.45 0 5.771-4.679 10.45-10.45 10.45z",
    fill: "url(#SVGID_26_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.288ef750.svg";
export { ForwardRef as ReactComponent };